import { forwardRef, type Ref, type SVGProps } from "react";
const IconKeyboardOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M29 6H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1m-1 16H4V8h24Z"
    />
    <path
      fill="currentColor"
      d="M7 10h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2zm4 0h2v2h-2zm4 0h2v2h-2zM7 14h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2zm4 0h2v2h-2zm4 0h2v2h-2zM7 18h2v2H7zm4 0h10v2H11zm12 0h2v2h-2z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconKeyboardOutlineSVG);
ForwardRef.displayName = "IconKeyboardOutline";
export { ForwardRef as IconKeyboardOutline };
